export default __webpack_public_path__ + "static/media/butterfly@3x.e4fa9494.png";